import React from 'react';

export interface LockBrand {
  key: string;
  name: string;
  logo: string;
  color: string;
}

// All Seam-based smart lock brands have been removed
// Only PDK, Brivo, and Bridge providers are supported
export const LOCK_BRANDS: LockBrand[] = [];

const brandColors: Record<string, string> = {
  orange: 'border-orange-500 bg-orange-50',
  blue: 'border-emerald-500 bg-emerald-50',
  green: 'border-green-500 bg-green-50',
  yellow: 'border-yellow-500 bg-yellow-50',
  purple: 'border-purple-500 bg-purple-50',
};

interface Props {
  onSelect: (brand: LockBrand) => void;
  selectedKey?: string;
}

export const BrandPicker: React.FC<Props> = ({ onSelect, selectedKey }) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
      {LOCK_BRANDS.map((brand) => {
        const isSelected = selectedKey === brand.key;
        return (
          <button
            key={brand.key}
            onClick={() => onSelect(brand)}
            className={`p-4 rounded-xl border-2 text-center transition-all hover:shadow-md ${
              isSelected
                ? brandColors[brand.color]
                : 'border-gray-200 hover:border-gray-300 bg-white'
            }`}
          >
            <span className="text-3xl block mb-2">{brand.logo}</span>
            <p className="font-semibold text-gray-900 text-sm">{brand.name}</p>
          </button>
        );
      })}
    </div>
  );
};
